// Team-related types
export enum TeamMemberRole {
    Admin = 'Admin',
    Researcher = 'Researcher',
    Viewer = 'Viewer',
}

export interface TeamMember {
    id: string;
    /** Raw Firebase auth uid of the team member. Distinct from `id`, which
        is the composite `${uid}-${projectId}` used as the Firestore doc id
        (see functions/src/index.ts joinProject). Use this when matching
        against raw auth uids (e.g. `nudge.sentBy`). */
    userId?: string;
    organizationId?: string;
    projectId?: string;
    name: string;
    email: string;
    avatarUrl: string;
    role: TeamMemberRole;
    lastActiveAt?: any;
}

export interface Invitation {
    id: string;
    email: string;
    organizationId?: string;
    role: TeamMemberRole;
    status: 'pending';
}
